import { render, staticRenderFns } from "./ModalAcceptance.vue?vue&type=template&id=e6ad63d6&scoped=true&"
import script from "./ModalAcceptance.vue?vue&type=script&lang=js&"
export * from "./ModalAcceptance.vue?vue&type=script&lang=js&"
import style0 from "./ModalAcceptance.vue?vue&type=style&index=0&id=e6ad63d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6ad63d6",
  null
  
)

export default component.exports